import React from 'react';
import { StarIcon, QuoteIcon, BadgeCheckIcon } from 'lucide-react';
import { clientTestimonials } from '../data/clientTestimonials';
import { CTAButton } from './ui/CTAButton';
export function ClientTestimonialsSection() {
  return <section id="testimonios" className="relative overflow-hidden border-t border-[#D89A3D]/20 bg-[#111111]" aria-labelledby="client-testimonials-title" data-id="element-32" data-mp="336c426enee4p">
      <div className="blueprint-grid absolute inset-0 opacity-40" aria-hidden="true" data-id="element-33" data-mp="2aj85oka28y1w" />
      <div className="absolute left-1/2 top-0 h-[420px] w-[760px] -translate-x-1/2 rounded-full bg-[#FF7A00]/8 blur-[150px]" aria-hidden="true" data-id="element-34" data-mp="26h4pxjgcz7at" />

      <div className="relative mx-auto max-w-content px-4 py-16 md:px-8 md:py-24" data-id="element-35" data-mp="2k9ucpq3pog8z">
        <div className="mx-auto max-w-3xl text-center" data-id="element-36" data-mp="2ff6prvocvtwi">
          <p className="font-display text-[10px] font-extrabold uppercase tracking-[0.24em] text-[#FF7A00]" data-id="element-37" data-mp="1rqngpdxhfd3d">
            Historias reales
          </p>
          <h2 id="client-testimonials-title" className="title-glow reveal mt-4 font-display text-2xl font-black uppercase leading-[1.08] tracking-tight text-[#F8F3EA] sm:text-4xl" data-id="element-38" data-mp="1mqrlo46rivzy">
            Lo que dicen quienes ya{' '}
            <span className="accent-glow text-[#FF7A00]" data-id="element-39" data-mp="1059t17gjn20z">abrieron la Bóveda</span>
          </h2>
          <div className="gold-rule mx-auto mt-6 w-48" aria-hidden="true" data-id="element-40" data-mp="151qic4zhbmfn" />
          <p className="mt-6 text-[15px] leading-relaxed text-[#EFEDE8]/70 sm:text-base" data-id="element-41" data-mp="7ft8sx32urfu">
            Carpinteros, emprendedores y personas que arrancaron desde cero en distintos
            puntos del país.
          </p>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-42" data-mp="hbw87v6jobz3">
          {clientTestimonials.map(testimonial => <li key={testimonial.name} className="premium-card reveal flex flex-col rounded-2xl border border-[#D89A3D]/20 bg-[#181512] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#FF7A00]/50 hover:shadow-[inset_0_1px_0_rgba(248,243,234,0.08),0_0_0_1px_rgba(216,154,61,0.28),0_0_46px_-14px_rgba(255,122,0,0.55),0_26px_60px_-32px_rgba(0,0,0,0.95)]" data-id="element-43" data-mp="lcpvqng2rorg">
              <div className="flex items-center justify-between gap-3" data-id="element-44" data-mp="6q5wpqf7jpju">
                <div className="flex gap-0.5" aria-label={`${testimonial.stars} de 5 estrellas`} data-id="element-45" data-mp="6o1r941nuihg">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${i < testimonial.stars ? 'fill-[#FF7A00] text-[#FF7A00]' : 'text-[#EFEDE8]/20'}`} aria-hidden="true" data-id="element-46" data-mp="3662jhp8albyz" data-mpi={i} />)}
                </div>
                <QuoteIcon className="h-5 w-5 text-[#D89A3D]/40" aria-hidden="true" data-id="element-47" data-mp="2mhtm90rw6fsm" />
              </div>

              <p className="mt-4 flex-1 text-[15px] leading-relaxed text-[#EFEDE8]/80" data-id="element-48" data-mp="11x52kjsy6lbz">
                “{testimonial.quote}”
              </p>

              <div className="mt-6 flex items-center gap-3 border-t border-[#D89A3D]/15 pt-5" data-id="element-49" data-mp="szclba3o13ly">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#FF7A00]/40 bg-[#111111] font-display text-sm font-extrabold text-[#FF7A00]" data-id="element-50" data-mp="xwuwl755nux4">
                  {testimonial.name.charAt(0)}
                </span>
                <div className="min-w-0" data-id="element-51" data-mp="1pmhl4aa605qy">
                  <p className="flex items-center gap-1.5 font-display text-sm font-extrabold uppercase tracking-tight text-[#F8F3EA]" data-id="element-52" data-mp="1bpua53ldnf21">
                    {testimonial.name}
                    <BadgeCheckIcon className="h-4 w-4 shrink-0 text-[#FF7A00]" aria-label="Compra verificada" data-id="element-53" data-mp="a5nyefy6k2a" />
                  </p>
                  <p className="text-xs text-[#D89A3D]" data-id="element-54" data-mp="kidm050vlueu">{testimonial.role}</p>
                  <p className="text-xs text-[#EFEDE8]/50" data-id="element-55" data-mp="kkglrgrtz1wr">{testimonial.city}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="reveal mt-12 flex flex-col items-center" data-id="element-56" data-mp="br3ltuvcn016">
          <CTAButton href="#oferta" size="large" data-id="element-57" data-mp="6rqxt6sqrmx0">
            🔓 Quiero acceder ahora
          </CTAButton>
          <p className="mt-3 text-xs text-[#EFEDE8]/50" data-id="element-58" data-mp="13hrk8z5n1rb5">
            Pago único · Acceso digital · Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}